import { render, staticRenderFns } from "./CustomerDefault.vue?vue&type=template&id=0974c2b0&"
import script from "./CustomerDefault.vue?vue&type=script&lang=js&"
export * from "./CustomerDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports